import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "footer-link",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args)))
    }, _toDisplayString(_ctx.privacyText), 1),
    _createElementVNode("span", null, _toDisplayString(_ctx.version) + " | " + _toDisplayString(_ctx.copyRightText), 1)
  ]))
}